import { type FC, type PropsWithChildren, useEffect, useMemo } from 'react'

import { ConfigProvider } from 'antd'
import ru_RU from 'antd/locale/ru_RU'
import { useSelector } from 'react-redux'

import { syncRegisteredChartTheme } from '@web/entities/chart/lib/chart-theme-sync'
import { selectBorderRadius, selectTheme } from '@web/entities/settings'
import { getDesignTokensAntd } from '@web/shared/constants/design-tokens-antd.constant'

export const AppThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const themeName = useSelector(selectTheme)
  const radiusMode = useSelector(selectBorderRadius)
  const antdTheme = useMemo(
    () => getDesignTokensAntd(themeName, radiusMode),
    [themeName, radiusMode]
  )

  useEffect(() => {
    // Chart.js загружается только при первом открытии экрана с графиком.
    syncRegisteredChartTheme()
  }, [themeName])

  return (
    <ConfigProvider locale={ru_RU} theme={antdTheme}>
      {children}
    </ConfigProvider>
  )
}
